import { useEffect } from 'react'

import { connect  } from 'react-redux';
import { fetchProducts , addProductToCart , increaseProduct } from '../../store/actions/index';

import Product from '../../components/Product/Product';
import CircularProgress from '@mui/material/CircularProgress';


import styled from 'styled-components';

import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';


const StoreContainer = styled.div`
    min-height: 100vh;
    padding: 10% 5%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Store = props => {

    const { fetchProductsHandler , loadingProducts , fetchedProducts, buyProductHandler, cartItems , increaseProductQuantity, errorLoading } = props;

    useEffect(() => {
        fetchProductsHandler()
    }, [ fetchProductsHandler ]);

    const addProductHandler =  ( id , quantity = 1 ) => {
        let addedProduct = null ;
        if ( cartItems.some( item => item.id === id ) ) {
            const orderIndex =  cartItems.findIndex( item => item.id === id )
            increaseProductQuantity( cartItems[orderIndex].orderId , cartItems[orderIndex].quantity + quantity , quantity);
        } else {
            const productIndex =  fetchedProducts.findIndex( item => item.id === id );
            addedProduct = {...fetchedProducts[productIndex] , quantity: quantity};
            buyProductHandler(addedProduct);
        }
    };

    let fetchedColors = [ ];

    if(fetchedProducts.length > 0) {
        fetchedColors = fetchedProducts.map( item => {
        return (
                <Grid item xs={12} sm={6} md={4} xl={3} key={item.id}>
                    <Product id={item.id} name={item.name} colorValue={ '#'+item.imageColor} 
                        price={item.price} buyProduct={addProductHandler}
                    />
                </Grid>
            )
        })
    }

    const loadingStoreContent = <CircularProgress />

    const fetchedStoreContent = ( 
        <Grid container spacing={ 4 } >
            {fetchedColors}
        </Grid>
    )
    const errorLoadingStoreContent = <Alert severity="error">This is an error alert — check it out!</Alert>

    return (
        <StoreContainer>
            { loadingProducts &&  loadingStoreContent }
            { !loadingProducts && fetchedProducts.length > 0 &&  fetchedStoreContent }
            { !loadingProducts && errorLoading &&  errorLoadingStoreContent }
        </StoreContainer>
    )
}

const mapStateToProps = state =>{
    return {
        fetchedProducts: state.prod.products,
        loadingProducts: state.prod.fetchingProducts,
        errorLoading: state.prod.error,
        cartItems: state.cart.cartItems
    }
}
const mapDispatchToProps = dispatch =>{
    return {
        fetchProductsHandler : ( ) => dispatch( fetchProducts( ) ),
        buyProductHandler: ( ( product ) => dispatch( addProductToCart( product ) )),
        increaseProductQuantity : ( id, quantity, quantityAdded ) => dispatch ( increaseProduct(  id, quantity, quantityAdded ) )
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Store);